import { searchAndloadMoreArticles } from "../../acervo-digital/publicacoes/index.js";

document.addEventListener('DOMContentLoaded', () => {
    searchAndloadMoreArticles();
})